import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../../core/converter/httpModel.converter';
import {CommunicationConfigurationEmailModel} from '../communicationConfigurationEmail.model';

@Injectable()
export class CommunicationConfigurationEmailConverter extends HttpModelConverter<CommunicationConfigurationEmailModel> {

    protected createInstance(): CommunicationConfigurationEmailModel {
        return new CommunicationConfigurationEmailModel();
    }

    protected enrichObject(result: CommunicationConfigurationEmailModel, src: CommunicationConfigurationEmailModel) {
    }
}
